// g0-re-request-decision-policy-change-line.ts — V2-1 review M4.
//
// Khi BLUEPRINT đổi sau G0, recheck re-request G0 với lý do "sha A → B". Nếu
// thay đổi đó lật `decision_policy` (vd `ask → auto`), người duyệt lại phải
// THẤY điều đó — không thì duyệt theo thói quen là vô tình cấp quyền tự quyết.
// So policy của bytes ĐÃ DUYỆT (theo hash cũ) với bytes mới; khác ⇒ một dòng
// để nối vào `reason`. Bytes cũ không tìm được ⇒ "không rõ" (vẫn báo nếu mới là auto).
import { readFile } from "node:fs/promises";
import { parseDecisionPolicyFromBlueprint } from "./decision-policy-blueprint-line-parser.js";
import { loadBlueprintBytesWithHash } from "./g0-approved-blueprint-bytes-lookup.js";

export async function describeDecisionPolicyChange(input: {
  controlRoot: string;
  repoDir: string;
  sourcePath: string;
  approvedHash: string;
  newBlueprintPath: string;
}): Promise<string | undefined> {
  try {
    const oldBytes = await loadBlueprintBytesWithHash(
      input.controlRoot,
      input.repoDir,
      input.sourcePath,
      input.approvedHash,
    );
    const before =
      oldBytes === undefined
        ? "không rõ"
        : parseDecisionPolicyFromBlueprint(oldBytes.toString("utf8")).policy;
    const after = parseDecisionPolicyFromBlueprint(
      await readFile(input.newBlueprintPath, "utf8"),
    ).policy;
    if (before === after || (before === "không rõ" && after === "ask")) return undefined;
    return `decision_policy: ${before} → ${after} (cần duyệt tường minh).`;
  } catch {
    return undefined;
  }
}
